import { IconBrandMeta } from '@tabler/icons-react'
import { Modal } from 'react-bootstrap'
import { baseURL } from '../Utils/constants/constant'

export const FbModal = ({ show, setShow }) => {
    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            contentClassName="border-0 shadow-lg rounded-3"
        >
            {/* Consistent Professional Header */}
            <Modal.Header closeButton className="border-bottom-0 pt-4 px-4 align-items-start">
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-start mb-1 gap-2">
                        <div
                            className="d-flex align-items-center justify-content-center rounded-2"
                            style={{
                                background: "linear-gradient(135deg, #7a3a5e 0%, #4f243c 100%)",
                                width: "38px",
                                height: "38px",
                                boxShadow: "0 4px 10px rgba(122, 58, 94, 0.2)"
                            }}
                        >
                            <IconBrandMeta stroke={2} size={20} color={"white"} />
                        </div>
                        <div className="d-flex flex-column">
                            <Modal.Title className="h5 fw-bold m-0" style={{ color: '#1a202c' }}>
                                Login and Sync Facebook Leads
                            </Modal.Title>
                            <small className="text-muted">
                                Give your current filter configuration a name for quick access later.
                            </small>
                        </div>
                    </div>

                </div>
            </Modal.Header>

            <Modal.Body className="px-4 py-3">

                {/* Custom Styled Footer inside Form */}
                <div className="d-flex justify-content-end gap-2 mt-4 pt-2 pb-2">

                    <button
                        type="button"
                        onClick={() => setShow(false)}
                        className="text-decoration-none btn-default-outline px-3 py-2 fw-medium transition-all"
                        style={{
                            color: "#64748b",
                            border: "1px solid #dee2e6",
                            fontSize: "13px",
                            borderRadius: "6px",
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={() => window.open(`${baseURL}/facebook`, "_self")}
                        className="px-4 py-2 fw-semibold shadow-sm btn-default transition-all"
                        style={{
                            color: "#fff",
                            border: "none",
                            fontSize: "14px",
                            borderRadius: "6px",
                        }}
                    >
                        Login
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
